import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Constants from '../Constants';
import { setUser } from '../redux/actions/users';
import useAxios from './useAxios';
import LoggedInUserService from '../services/AuthService';


const useUser = (isEnabled = true) => {
  const dispatch = useDispatch();
  const { getData } = useAxios();
  const user = useSelector((state) => state.users);

  const fetchAndStoreUser = () => {
    const loggedInUser = LoggedInUserService.GetLoggedInUserData();
    const userId = loggedInUser?.id;
    if (!userId) return;
    dispatch(setUser(loggedInUser));

    getData(`${Constants.ApiUrl.user.getUserById}/${userId}`).then(({ success, data }) => {
      if (!success) return;
      const teams = (data?.teams ?? []).map((team) => ({ key: team._id, text: team.name, value: team._id }));
      dispatch(setUser({ ...data, teams }));
    });
  }


  useEffect(() => {
    if (isEnabled) {
      fetchAndStoreUser()
    }
  }, [isEnabled, getData, dispatch]);

  return {
    user,
    fetchAndStoreUser
  };
};

export default useUser;
